import React from 'react';

import { useMediaQuery, useTheme } from '@material-ui/core';

import { NewMessageComposer } from '../new-message-composer/new-message-composer';

import { EmployeeGroupThread } from './employee-group-thread/employee-group-thread';
import { EmployeeThread } from './employee-thread/employee-thread';

import { getEmployeeGroupCountsFromEmployees } from '../../employees/utils/get-employee-groups-from-employees';
import { allEmployeesKey } from '../../util/all-employees-option';

type InputProps = {
  orgId: number;
  activeEmployee: Employee | undefined;
  activeGroup: EmployeeGroupWithAllOption | undefined;
  isComposingNewMessage: boolean;
  currentEmployees: Employee[];
  handleNewMessageToggle: () => void;
  handleMessageSent: (employeeId: number) => void;
  handleEmployeeClick: (
    newPopupEmployeeId: number,
    newSelectedTab: string,
  ) => (e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  handleMessageClick: ({
    employeeId,
    groupId,
  }: {
    employeeId?: number | null;
    groupId?: string | number | null;
  }) => () => void;
};

export const MessageThread = (props: InputProps) => {
  const {
    orgId,
    activeEmployee,
    activeGroup,
    isComposingNewMessage,
    currentEmployees,
    handleNewMessageToggle,
    handleMessageSent,
    handleEmployeeClick,
    handleMessageClick,
  } = props;

  const theme = useTheme();
  const isOnMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const groupMembershipCounts = Object.assign(
    getEmployeeGroupCountsFromEmployees(currentEmployees),
    { [allEmployeesKey(orgId)]: currentEmployees.length },
  );

  const mobileClass = isOnMobile ? 'u-width-100 u-flexShrink-0' : '';
  const hiddenClassNoSelected =
    isOnMobile && !activeEmployee && !isComposingNewMessage && !activeGroup ? 'u-display-none' : '';

  return (
    <div
      className={`u-flexColumn u-flexGrow-1 u-background-white ${mobileClass} ${hiddenClassNoSelected}`}
    >
      {isComposingNewMessage ? (
        <NewMessageComposer
          orgId={orgId}
          onMessageSent={handleMessageSent}
          onClose={handleNewMessageToggle}
        />
      ) : activeEmployee ? (
        <EmployeeThread
          employee={activeEmployee}
          orgId={orgId}
          handleEmployeeClick={handleEmployeeClick}
          onClose={handleMessageClick({})}
        />
      ) : activeGroup ? (
        <EmployeeGroupThread
          orgId={orgId}
          employeeGroup={activeGroup}
          onClose={handleMessageClick({})}
          groupMembershipCounts={groupMembershipCounts}
        />
      ) : null}
    </div>
  );
};
